import script from "./MentorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MentorPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QSelect,QBtn});
